{
  "home-page": {
    "meta": {
      "title": "Beauty Booking",
      "description": "réservation en ligne, rabais sur les ongles, offres sur les ongles, offres sur les ongles, rabais sur les sourcils, offres sur les sourcils, rabais sur les cils, offres sur les cils, offres sur les cils, rabais sur le PMU, offres sur le PMU, offres sur le PMU"
    },
    "text": {
      "book-appointment-again": "Prendre de nouveaux rendez-vous dans les salons que vous avez visités"
    }
  }
}
